module.exports = __webpack_public_path__ + "img/teams_logo.5f5b45d2.png";